import React from "react";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import SEO from "../common/SEO";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";

import seoData from "../seoData/WebDevelopment.json"
// import argumentTeam from "../assets/image/services/argumentTeam.svg"
// import liIcon from "../li-icon.svg"

const WebDevelopment = () => {
  return (
    <>
      <SEO {...seoData} />
      <ColorSwitcher />
      <main className="main-wrapper StaffAugmentation">
        <HeaderOne />
        <BreadCrumbOne title="Web Development" page="Web Development" />

        <div className="section section-padding pb-0">
          <div className="container">
            <section id="augmentation-card">
              <div className="py-4">
                <div className="section-header">
                  <h2 className="mb-3">Web Application Development Company</h2>
                  <p>
                    We build web applications that hold up under real usage —
                    not just demo-day traffic. That means picking a stack that
                    fits the actual problem rather than whatever's trending,
                    writing code a different developer can pick up a year from
                    now, and testing against the edge cases a happy-path demo
                    never hits.
                  </p>
                  <p>
                    Our process starts with understanding what the application
                    actually needs to do for its users, not just a feature
                    list. From there we move through design, development, and
                    testing in short, reviewable cycles, so you're seeing real
                    progress throughout the build instead of a single reveal
                    at the end.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-11 col-lg-9 mx-auto ms-lg-0">
                  <div className="augmentation-card">
                    <h3 className="augmentation-title num3">
                      1. Website Development
                    </h3>
                    <p className="mb-0 mt-3">
                      From a marketing site to a full custom web platform, we
                      build from a real information architecture and content
                      plan first, not a template filled in after the fact.
                      Every site we ship is built responsive from the start,
                      tested across real devices, and structured so a client's
                      own team can update content without needing a developer
                      for every small change.
                    </p>
                  </div>
                </div>
                <div className="col-11 col-lg-9 mt-4 mx-auto me-lg-4 ms-lg-auto">
                  <div className="augmentation-card">
                    <h3 className="augmentation-title num3">
                      2. E-Commerce Web App Development
                    </h3>
                    <p className="mb-0 mt-3">
                      We build storefronts around the parts of the funnel that
                      actually lose sales — a confusing checkout, a slow
                      product page, unclear shipping and return information.
                      That includes catalog and inventory management, payment
                      gateway integration, and analytics wired up from launch
                      so you can see what's actually converting, not guess at
                      it after the fact.
                    </p>
                  </div>
                </div>
                <div className="col-11 col-lg-9 mt-4 mx-auto ms-lg-0">
                  <div className="augmentation-card">
                    <h3 className="augmentation-title num3">
                      3. Software Development
                    </h3>
                    <p className="mb-0 mt-3">
                      Beyond websites, we build the custom internal tools and
                      platforms that off-the-shelf software doesn't quite fit
                      — a workflow that's specific to how your team actually
                      operates, an integration between two systems that don't
                      talk to each other natively, or a full product built
                      around a genuinely new idea. We scope these the same way
                      as any build: real requirements first, architecture
                      second, code third.
                    </p>
                  </div>
                </div>
                <div className="col-11 col-lg-9 mt-4 mx-auto me-lg-4 ms-lg-auto">
                  <div className="augmentation-card">
                    <h3 className="augmentation-title num3">
                      4. Web Application Testing
                    </h3>
                    <p className="mb-0 mt-3">
                      We combine automated testing — for the regressions that
                      are easy to catch mechanically — with manual testing for
                      the usability and edge-case issues automation misses
                      entirely. That includes functional testing across
                      browsers and devices, load testing for anything expecting
                      real traffic volume, and a security pass before
                      anything handling sensitive data goes live.
                    </p>
                  </div>
                </div>
                <div className="col-11 col-lg-9 mt-4 mx-auto ms-lg-0">
                  <div className="augmentation-card">
                    <h3 className="augmentation-title num3">
                      5. Web Application Support &amp; Maintenance
                    </h3>
                    <p className="mb-0 mt-3">
                      Launch is the start of a web application's life, not the
                      end of our involvement. We offer ongoing support
                      covering security patches, dependency updates, bug
                      fixes, and small feature additions, so an application
                      keeps working reliably as browsers, frameworks, and your
                      own business needs change around it.
                    </p>
                  </div>
                </div>
                <div className="col-11 col-lg-9 mt-4 mx-auto me-lg-4 ms-lg-auto">
                  <div className="augmentation-card">
                    <h3 className="augmentation-title num3">
                      6. Progressive Web Apps
                    </h3>
                    <p className="mb-0 mt-3">
                      A PWA gives you app-like features — offline access, push
                      notifications, home-screen installation — without the
                      cost and delay of a full native app store submission.
                      They're a strong fit for a business that wants a more
                      engaging mobile experience but doesn't yet have the
                      volume of users to justify maintaining two separate
                      native codebases alongside the web platform.
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <div className="row mt--60">
              <div className="col-lg-9">
                <h2 className="mb-3">Technologies we build with</h2>
                <p>
                  We pick the stack based on the project's real requirements —
                  team size, expected traffic, integration needs — rather than
                  defaulting to one framework for everything. On the front
                  end that's most often React or Angular; on the back end, a
                  mix of Node.js, PHP, and Java depending on what the rest of
                  a client's infrastructure already runs on. For content-led
                  sites where a client's team needs to manage their own
                  updates, we also build on WordPress when that's genuinely
                  the better fit for the project.
                </p>
              </div>
            </div>
            <div className="row mt--60">
              <div className="col-lg-9">
                <h2 className="mb-3">How a build actually runs</h2>
                <p>
                  We scope first — what the site or application needs to do,
                  who it's for, and what "done" actually means for this
                  project — before any development starts. From there we work
                  in short, reviewable cycles rather than disappearing for
                  weeks at a time, so you're seeing real, working progress
                  throughout the build instead of a single reveal near the
                  deadline. A typical build moves through design and
                  wireframes, development against that design, and a testing
                  pass covering both function and the edge cases a happy-path
                  demo tends to miss, before anything goes live.
                </p>
                <p>
                  A worked example: a client comes to us wanting an
                  e-commerce rebuild because their existing checkout was
                  losing sales. Before writing any code, we walk the current
                  funnel end to end to find where visitors are actually
                  dropping off — often it's a confusing shipping step or a
                  slow product page rather than the whole site — and scope
                  the rebuild around fixing that specific problem first,
                  rather than rebuilding everything at once.
                </p>
              </div>
            </div>
          </div>
          <ul className="list-unstyled shape-group-12">
            <li className="shape shape-1">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-2.png"}
                alt="Bubble"
              />
            </li>
            <li className="shape shape-2">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-1.png"}
                alt="Bubble"
              />
            </li>
            <li className="shape shape-3">
              <img
                src={process.env.PUBLIC_URL + "/images/others/circle-3.png"}
                alt="Circle"
              />
            </li>
          </ul>
        </div>

        <FooterOne parentClass="pt--150 pt_lg--100 pt_md--80 pt_sm--60" />
      </main>
    </>
  );
};

export default WebDevelopment;
